import { Loader2 } from 'lucide-react'

function PageLoader() {
  return (
    <div
      className="flex min-h-[60svh] items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="text-muted-foreground size-6 animate-spin" />
      <span className="sr-only">Loading…</span>
    </div>
  )
}

export { PageLoader }
